import { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";
import * as Parchment from "parchment";

// ✅ Enregistrement SÛR
Quill.register("modules/imageResize", ImageResize);

// Modules object for setting up the Quill editor
export const modules = {
  formula: true,

  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    [
      {
        font: [
          "arial",
          "comic-sans",
          "courier-new",
          "georgia",
          "helvetica",
          "Inter",
          "lucida",
        ],
      },
    ],
    [{ size: ["extra-small", "small", "medium", "large"] }],
    ["bold", "italic", "underline", "strike", "formula"],
    [{ script: "sub" }, { script: "super" }],
    [{ align: ["", "center", "right"] }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    [
      { background: ["", "#ffcc00", "#00ff00", "#0000ff", "#ff0000"] },
      {
        color: ["", "red", "green", "blue", "yellow", "orange", "pink", "gray"],
      },
    ],
    ["clean"],
  ],

  // ✅ VERSION STABLE
  imageResize: {
    parchment: Parchment,
    modules: ["Resize", "DisplaySize", "Toolbar"],
  },

  clipboard: {
    matchVisual: false,
  },

  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

// Formats objects for setting up the Quill editor
export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "color",
  "code-block",
  "formula",
];
